import React from 'react';
import './styles/style.css';
import App from './components/App';
import { render } from 'react-dom'
import registerServiceWorker from './registerServiceWorker';
import { BrowserRouter } from 'react-router-dom'

render((
    <BrowserRouter>
        <App />
    </BrowserRouter>
), document.getElementById('root'))

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js